import {
  Container,
  Paper,
  Typography,
  Box,
  Grid,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import FlagIcon from "@mui/icons-material/Flag";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useEffect, useState } from "react";
import AppBreadcrumbs from "../../components/shared/Breadcrumbs/AppBreadcrumbs";
import { getCdmpOverview } from "../../api/cdmpOverview";
import { useLanguage } from "../../context/LanguageContext";
import DemoNoticeDialog from "../../components/DemoNoticeDialog/DemoNoticeDialog";

const OverviewPage = () => {
  const [pageData, setPageData] = useState(null);
  const { language } = useLanguage();

  useEffect(() => {
    fetchData();
  }, [language]);

  const fetchData = async () => {
    try {
      const data = await getCdmpOverview(language);
      setPageData(data);
    } catch (err) {
      console.error("Hero fetch error", err);
    }
  };

  if (!pageData) return <Typography>Loading...</Typography>;

  const govtColors = {
    saffron: '#FF9933',
    green: '#138808',
    navy: '#0B2A4A',
    blue: '#1E3A8A',
    red: '#B22222',
    blue1: '#65c7f5'
  };

  const sections = [
    {
      id: 'overview',
      icon: <VisibilityIcon sx={{ fontSize: 28 }} />,
      title: pageData.overview,
      content: pageData.overviewContent,
      // color: govtColors.navy,
      // bgLight: '#E8EEF5',
      color: govtColors.blue,
      bgLight: '#E3F2FD',
    },
    {
      id: 'need',
      icon: <FlagIcon sx={{ fontSize: 28 }} />,
      title: pageData.needOfCdmpHeading,
      content: pageData.needOfCdmpContent,
      // color: govtColors.saffron,
      // bgLight: '#FFF4E5',
      color: govtColors.blue,
      bgLight: '#E3F2FD',
    },
    {
      id: 'objectives',
      icon: <CheckCircleIcon sx={{ fontSize: 28 }} />,
      title: pageData.objectivesOfCdmpHeading,
      content: pageData.objectivesOfCdmpContent,
      // color: govtColors.green,
      // bgLight: '#E8F5E9',
      color: govtColors.blue,
      bgLight: '#E3F2FD',
    },
    {
      id: 'evolution',
      icon: <VisibilityIcon sx={{ fontSize: 28 }} />,
      title: pageData.evolutionOfCdmpHeading,
      content: pageData.evolutionOfCdmpContent,
      // color: govtColors.blue,
      // bgLight: '#E3F2FD',
      color: govtColors.blue,
      bgLight: '#E3F2FD',
    },
    {
      id: 'act',
      icon: <CheckCircleIcon sx={{ fontSize: 28 }} />,
      title: pageData.DisasterManagementAct2005Heading,
      content: pageData.DisasterManagementAct2005Content,
      // color: govtColors.red,
      // bgLight: '#FDECEA',
      color: govtColors.blue,
      bgLight: '#E3F2FD',
    },
  ];

  return (
    <Box sx={{ bgcolor: '#F0F2F5', minHeight: '100vh', py: 4 }}>
      <Container maxWidth="lg">
        {/* Only Breadcrumb */}
        <Box sx={{ mb: 3 }}>
           <DemoNoticeDialog />
          <AppBreadcrumbs
            items={[
              { label: "Home", path: "/" },
              { label: "About CDMP 2026", path: "/cdmp/documents" },
              { label: pageData.breadcrumb || "Overview" },
            ]}
          />
        </Box>

        {/* Only Cards - No Header/Footer */}
        <Grid container spacing={3}>
          {sections.map((section) => (
            <Grid item xs={12} key={section.id}>
              <Paper
                elevation={0}
                sx={{
                  borderRadius: 3,
                  border: '1px solid',
                  borderColor: section.color + '40',
                  overflow: 'hidden',
                }}
              >
                {/* Section Header */}
                <Box
                  sx={{
                    bgcolor: section.bgLight,
                    p: { xs: 2, md: 3 },
                    borderBottom: `2px solid ${section.color}`,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                  }}
                >
                  {/* Icon Circle */}
                  <Box
                    sx={{
                      width: { xs: 40, md: 30 },
                      height: { xs: 40, md: 30 },
                      borderRadius: '50%',
                      bgcolor: 'white',
                      border: `3px solid ${section.color}`,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: section.color,
                      flexShrink: 0,
                    }}
                  >
                    {section.icon}
                  </Box>

                  {/* Title */}
                  <Box sx={{ flex: 1 }}>
                    <Typography
                      variant="h4"
                      sx={{
                        fontWeight: 700,
                        color: section.color,
                        fontSize: { xs: '1.3rem', md: '1.3rem' },
                      }}
                    >
                      {section.title}
                    </Typography>
                  </Box>
                </Box>

                {/* Content - Only API data */}
                <Box sx={{ p: { xs: 3, md: 4 } }}>
                  <Typography
                    sx={{
                      color: '#333',
                      lineHeight: 1.9,
                      fontSize: { xs: '0.95rem', md: '1.05rem' },
                      whiteSpace: 'pre-line',
                    }}
                  >
                    {section.content}
                  </Typography>
                </Box>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default OverviewPage;


// import { Container, Paper, Typography, Box } from "@mui/material";
// import AppBreadcrumbs from "../../components/shared/Breadcrumbs/AppBreadcrumbs";
// import PageHeader from "../../components/shared/PageHeader/PageHeader";

// const OVERVIEW_PAGE_CONFIG = {
//   breadcrumb: "Overview",
//   title: "Overview, Vision, Mission, Objectives",
//   description:
//     "City Disaster Management Plan focusing on preparedness, response, and recovery.",
//   sections: [
//     {
//       heading: "Vision",
//       content:
//         "To build a disaster-resilient city that minimizes loss of life, property, and disruption to essential services through comprehensive preparedness, effective response, and sustainable recovery mechanisms.",
//     },
//     {
//       heading: "Mission",
//       content:
//         "Our mission is to establish a robust disaster management framework that integrates prevention, mitigation, preparedness, response, recovery, and reconstruction strategies through multi-stakeholder collaboration and community participation.",
//     },
//     {
//       heading: "Objectives",
//       list: [
//         "Develop comprehensive risk assessment and mitigation strategies",
//         "Strengthen institutional capacity and inter-agency coordination",
//         "Enhance community awareness and participation",
//         "Establish effective early warning and response systems",
//         "Facilitate rapid and sustainable recovery and reconstruction",
//       ],
//     },
//   ],
// };

// const OverviewPage = () => {
//   const pageData = OVERVIEW_PAGE_CONFIG;

//   return (
//     <Container maxWidth="lg" sx={{ mt: 4, mb: 6 }}>
//       {/* Breadcrumb (same as CdmpPage) */}
//       <AppBreadcrumbs
//         items={[
//           { label: "Home", path: "/" },
//           { label: "About CDMP 2026", path: "/cdmp/documents" },
//           { label: pageData.breadcrumb },
//         ]}
//       />

//       {/* Header */}
//       <PageHeader
//         title={pageData.title}
//         description={pageData.description}
//       />

//       {/* White Content Card */}
//       <Paper
//         sx={{
//           p: { xs: 2, md: 4 },
//           borderRadius: 3,
//           border: "1px solid #e0e0e0",
//         }}
//       >
//         {pageData.sections.map((section, index) => (
//           <Box key={index} mb={4}>
//             <Typography variant="h5" fontWeight={600} mb={1}>
//               {section.heading}
//             </Typography>

//             {section.content && (
//               <Typography>{section.content}</Typography>
//             )}

//             {section.list && (
//               <Box component="ul" sx={{ pl: 3 }}>
//                 {section.list.map((item, i) => (
//                   <li key={i}>{item}</li>
//                 ))}
//               </Box>
//             )}
//           </Box>
//         ))}
//       </Paper>
//     </Container>
//   );
// };

// export default OverviewPage;
